var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg103Headphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432,264h-40c-11.046,0-20,8.954-20,20v208c0,11.046,8.954,20,20,20h40c44.112,0,80-35.888,80-80v-88 C512,299.888,476.112,264,432,264z M472,432c0,22.056-17.944,40-40,40h-20V304h20c22.056,0,40,17.944,40,40V432z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,40c91.623,0,166.972,68.705,175.267,159.813c1.001,11,10.738,19.101,21.731,18.104 c11-1.001,19.105-10.731,18.104-21.731c-4.866-53.44-29.397-102.928-69.076-139.35C362.097,20.185,310.236,0,256,0 c-57.696,0-111.938,22.468-152.735,63.265S40,158.304,40,216v58.737C16.105,288.589,0,314.449,0,344v88c0,44.112,35.888,80,80,80 h40c11.046,0,20-8.954,20-20V284c0-11.046-8.954-20-20-20H80v-48C80,118.953,158.953,40,256,40z M100,304v168H80 c-22.056,0-40-17.944-40-40v-88c0-22.056,17.944-40,40-40H100z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg103Headphones);
export default __webpack_public_path__ + "static/media/103-headphones.bc5b9c44d173b56f9d2dd8311fcbe0e9.svg";
export { ForwardRef as ReactComponent };